class FuelEconomicData {
    public name: string = ""
    public code: string = ""
    public annualConsumption: number = 0
    public price: number = 0
    public annualPriceIncrease: number = 0
    public consumptionInTons: boolean = false
    public consumptionInTonsName: string = "MWh"
}

export default FuelEconomicData
